var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-found-page"},[_c('HeaderWithTitleAndIcon',{scopedSlots:_vm._u([{key:"header-title",fn:function(){return [_vm._v(" 404 Not Found ")]},proxy:true}])}),_c('p',[_vm._v(" Please check if the URL is correct or click the ICON to return to the homepage. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }